import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson33: FunctionComponent = () => {
  return (
    <div className="relative [background:linear-gradient(111.77deg,_rgba(0,_0,_0,_0),_#363636_78.54%),_#0d0d0d] w-full overflow-hidden flex flex-col items-center justify-center pt-[2.69rem] px-[2.69rem] pb-[7.63rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV dimensionCode="/nav@2x.png" navIconFlexShrink="unset" />
      <div className="self-stretch flex flex-row items-center justify-between">
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson32"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Back
          </b>
        </div>
        </a>
        <div className="self-stretch flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[100%]">{`Proteins `}</b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson34"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Next
          </b>
        </div>
        </a>
      </div>
      <div className="w-full flex flex-col items-center justify-center gap-[9.63rem] max-w-[125rem] text-justify text-[1.88rem] text-white font-dm-sans">
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Protein Importance</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                <span>
                  Protein is one of three essential macronutrients, alongside
                  carbohydrates and fats. These are nutrients that the human
                  body needs in relatively large quantities to function
                  properly.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Proteins are the main building blocks of your body. They’re
                  used to make muscles, tendons, organs, and skin, as well as
                  enzymes, hormones, neurotransmitters, and various molecules
                  that serve many important functions.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Proteins consist of smaller molecules called amino acids,
                  which link together like beads on a string. Your body produces
                  some of these amino acids, but you must obtain others known as
                  essential amino acids via your diet.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Different dietary sources of protein have different amino acid
                  compositions. Many lean meats and dairy products contain all
                  the ‘essential’ amino acids, while these are less abundant in
                  a plant-based diet.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  However, with a small amount of research and nutritional
                  consideration, it is perfectly possible to get all the
                  essential protein elements in good quantities on a plant-based
                  diet. For example, complete vegan protein powders and other
                  supplements are a helpful way to reach protein targets.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>SUMMARY</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Protein is a structural molecule comprising amino acids, many
                  of which your body can’t produce on its own. Animal foods are
                  usually high in protein, providing all essential amino acids.
                </span>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Protein Weight Loss</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                <span>
                  Protein is important when it comes to losing weight. As you
                  may know, you need to consume fewer calories than you burn to
                  lose weight.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Evidence suggests that eating protein can increase the number
                  of calories you burn by boosting your metabolic rate (calories
                  out) and reducing your appetite (calories in).
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  A 2020 review and meta-analysis concluded that a long-term
                  high protein diet could increase weight loss, reduce the risk
                  of gaining weight back, and help prevent obesity and
                  obesity-related diseases.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>SUMMARY</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  A protein intake at around 30% of calories seems to be optimal
                  for weight loss. It boosts your metabolic rate and causes a
                  spontaneous reduction in calorie intake.
                </span>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>{`Muscle & Strength Growth`}</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                <span>
                  As with most body tissues, muscles are dynamic and constantly
                  being broken down and rebuilt. To gain muscle, your body must
                  synthesize more muscle protein than it breaks down.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  As such, people who want to build muscle often eat more
                  protein, as well as exercise. A higher protein intake can help
                  build muscle and strength.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  For example, a 2018 meta-analysis concluded that dietary
                  protein supplementation significantly increased muscle
                  strength and size following a weight training program in
                  healthy adults.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  The authors of the above analysis found that protein intakes
                  of 1.6 g/kg/day were adequate to support muscle building and
                  improve performance.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>SUMMARY</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  It’s important to eat enough protein if you want to gain
                  and/or maintain muscle. Most studies suggest that 0.7–1 gram
                  per pound (1.6–2.2 grams per kg) of lean mass are sufficient.
                </span>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>Healthy Choices</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                When buying meat, go for the leanest option. As a rule, the more
                white you can see on meat, the more fat it contains. For
                example, back bacon contains less fat than streaky bacon.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>These tips can help you buy healthier options:</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Ask your butcher for a lean cut</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  If you're buying pre-packed meat, check the nutrition label to
                  see how much fat it contains and compare products
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Go for turkey and chicken without the skin as these are lower
                  in fat (or remove the skin before cooking)
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Try to limit processed meat products such as sausages, salami,
                  pâté and beefburgers, because these are generally high in fat
                  – they are often high in salt, too
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li>
              <span>
                <span>
                  Try to limit meat products in pastry, such as pies and sausage
                  rolls, because they are often high in fat and salt
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>Cutting Down on Fat</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Cut off any visible fat and skin before cooking – crackling and
                poultry skin are much higher in fat than the meat itself.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Here are some other ways to reduce fat when cooking meat:
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Grill meat, rather than frying</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Avoid adding extra fat or oil when cooking meat</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Roast meat on a metal rack above a roasting tin so the fat can
                  run off
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li>
              <span>
                <span>
                  Try using smaller quantities of meat and replacing some of the
                  meat with vegetables, pulses and starchy foods in dishes such
                  as stews, curries and casseroles
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-left">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Lean Beef</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  <span>
                    Lean beef is a rich source of protein. It’s also high in
                    bioavailable iron, zinc, selenium, and vitamins B12 and B6
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Red meat can be a part of a healthy diet, but it’s best to
                    moderate your intake. Consuming high amounts of red meat has
                    been linked to a higher risk of developing certain health
                    conditions, including colorectal cancer.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Some meats are high in saturated fat, which can raise blood
                    cholesterol levels if you eat too much of it. Making
                    healthier choices can help you eat meat as part of a
                    balanced diet.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Food hygiene is important when storing, preparing and
                    cooking meat.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Try cutting back on red meat and eating plant-based protein,
                    fish, and poultry more frequently.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <b>&nbsp;</b>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <b>Protein Content</b>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    A 3-ounce (85-g) serving of lean beef provides 24.6 g of
                    protein.
                  </span>
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[28.31rem] object-cover"
            alt=""
            src="/1921@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-left">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Chicken Breast</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  <span>
                    Chicken breast is an excellent choice if you’re trying to
                    increase your protein intake. In addition to protein,
                    chicken provides a variety of B vitamins, plus minerals like
                    zinc and selenium.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <b>Protein Content</b>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    One half of a chicken breast (86 g) provides 26.7 g of
                    protein.
                  </span>
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[22.69rem] object-cover"
            alt=""
            src="/193@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-left">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Turkey Breast</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  <span>
                    Turkey breast consists mostly of protein, with very little
                    fat and few calories. It also contains several vitamins and
                    minerals, including selenium, zinc, and vitamins B12 and B6.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <b>Protein Content</b>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    A 3-ounce (85-g) serving of turkey provides 25.6 g of
                    protein.
                  </span>
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[22rem] object-cover"
            alt=""
            src="/194@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-left">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Fish</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  <span>
                    Fish is an excellent source of protein and provides several
                    important vitamins and minerals, like iodine, selenium, and
                    vitamin B12.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    People who include a lot of fish in their diet tend to have
                    a lower risk of health conditions like heart disease and
                    type 2 diabetes. Plus, fatty fish like salmon and herring
                    are high in omega-3 fats, which have powerful benefits for
                    your overall health, including supporting heart health. Aim
                    to eat at least 2 portions of fish a week, including 1
                    portion of oily fish.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <b>Protein Content</b>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    All types of fish are high in protein. For example, half a
                    salmon fillet (124 g) provides 30.5 g of protein, while a
                    cod fillet (180 g) provides 41 g of protein.
                  </span>
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[31.5rem] object-cover"
            alt=""
            src="/195@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-left">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Eggs</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  <span>
                    Eggs and fish are also good sources of protein, and contain
                    many vitamins and minerals. Oily fish is particularly rich
                    in omega-3 fatty acids. Egg whites are almost pure protein,
                    but whole eggs that include the yolk provide many more
                    nutrients, including vitamins, minerals, antioxidants, and
                    healthy fats.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <b>Protein Content</b>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>One large egg (50 g) provides 6.3 g of protein.</span>
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[22.63rem] object-cover"
            alt=""
            src="/196@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-left">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Almonds</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  <span>
                    Almonds are high in plant based protein, antioxidants,
                    vitamin E, protein, fiber, manganese, and magnesium. This
                    nutrient-rich nut is an excellent addition to any diet since
                    it is a versatile ingredient linked to several health
                    benefits.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Eating almonds may benefit your health in several ways,
                    including lowering heart disease risk factors like high LDL
                    (bad) cholesterol and high blood pressure.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <b>&nbsp;</b>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <b>Protein Content</b>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    One ounce (28.35 g) of almonds provides 6 g of protein.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Other high protein nuts include pistachios, which deliver
                    5.73 g per 1-ounce (28.35 g) serving and cashews, which
                    contain 4.34 g of protein per 1-ounce (28.35-g) serving.
                  </span>
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[32.69rem] object-cover"
            alt=""
            src="/197@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-left">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Cottage Cheese</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  <span>
                    Cottage cheese is a type of cheese that is low in fat and
                    calories yet high in protein. It’s rich in calcium,
                    phosphorus, selenium, vitamin B12, riboflavin (vitamin B2),
                    and various other nutrients.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <b>&nbsp;</b>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <b>Protein Content</b>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    One cup (226 g) of cottage cheese provides 28 g of protein.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Other high protein cheeses include cheddar cheese, which
                    provides 3.96 g of protein per 17-g slice, and mozzarella,
                    which provides 6.29 g of protein per 1 ounce (28.35 g).
                  </span>
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[23.94rem] object-cover"
            alt=""
            src="/198@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-left">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Greek Yogurt</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  <span>
                    Greek yogurt, also called strained yogurt, is a very thick
                    type of yogurt high in protein.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    It has a creamy texture and is a good source of many
                    nutrients like calcium, vitamin B12, vitamin A, selenium,
                    and zinc.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <b>&nbsp;</b>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <b>Protein Content</b>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>One 7-ounce (200-g) container provides 19.9 g</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>.</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Other yogurt products that are high in protein include
                    unsweetened low fat yogurt, which provides 11.9 g of protein
                    per 8-ounce (227-g) container, and kefir, which provides
                    9.21 g of protein per 1 cup (243 mL).
                  </span>
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[23.94rem] object-cover"
            alt=""
            src="/199@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-left">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Milk</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  <span>
                    Dairy milk contains a little of nearly every nutrient that
                    your body needs. It’s a good source of high quality protein,
                    and it’s high in vitamins and minerals, like calcium,
                    phosphorus, and riboflavin (vitamin B2).
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Many people with lactose intolerance can’t tolerate milk and
                    other dairy products, and they avoid many dairy-containing
                    foods.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <b>Protein Content</b>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    One cup (246 mL) of dairy milk provides 8.32 g of protein.
                  </span>
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[31.38rem] object-cover"
            alt=""
            src="/200@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-left">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Lentils</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  <span>
                    Lentils are among the richest sources of plant-based
                    protein, making them an excellent choice if you follow a
                    vegetarian or vegan diet.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Plus, they’re loaded with other nutrients, too, including
                    fiber, folate, magnesium, potassium, iron, copper, and
                    manganese.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Studies show that people who regularly consume lentils and
                    other legumes have a lower risk of developing health
                    conditions like heart disease and fatty liver disease.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <b>Protein Content</b>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    100 g (about 1/2 cup) of cooked lentils provides 9.02 g of
                    protein.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Other high-protein legumes include chickpeas, which provide
                    7.05 g of protein per 100 g cooked, and black beans, which
                    provide 8.86 g of protein per 100 g cooked.
                  </span>
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[31.38rem] object-cover"
            alt=""
            src="/201@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-left">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Quinoa</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  <span>
                    Quinoa is rich in fiber, folate, copper, iron, and zinc, and
                    it’s higher in protein than many grains.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Quinoa is often referred to as a complete protein because it
                    contains all nine essential amino acids that your body can’t
                    make on its own. However, it actually contains insufficient
                    amounts of certain amino acids, like leucine.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <b>&nbsp;</b>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <b>Protein Content</b>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    One cup (185 g) of cooked quinoa provides 8 g of protein.
                  </span>
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[25.25rem] object-cover"
            alt=""
            src="/202@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-left">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Protein Powders</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  <span>
                    When you’re pressed for time and unable to prepare a meal,
                    protein powder can come in handy.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    You can easily add protein powders like whey and pea protein
                    to shakes, smoothies, energy balls, yogurt, and more to
                    increase the protein and fullness factor.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <b>Protein Content</b>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Whey protein powder provides about 16.6 g of protein per
                    scoop (28.6 g), while pea protein provides 15 g of protein
                    per scoop (20 g).
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Note that the protein content per scoop differs between
                    products, even when the scoop size is the same.
                  </span>
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[33.19rem] object-cover"
            alt=""
            src="/203@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-left">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Pumpkin Seeds</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  <span>
                    Pumpkin seeds are a great source of minerals like iron,
                    phosphorus, magnesium, and zinc. Plus, they’re loaded with
                    plant-based protein and fiber.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Try adding pumpkin seeds to salads, baked goods, oatmeal, or
                    yogurt, or mix them with unsweetened dried fruit and almonds
                    for a convenient snack.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <b>Protein Content</b>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    A 1/4 cup (29.5 g) of pumpkin seeds provides 8.8 g of
                    protein.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Other high protein seeds include sunflower seeds, which
                    provide 7.25 g per 1/4-cup (35-g) serving, and flax seeds,
                    which provide 7.5 g of protein per 1/4-cup (42-g) serving.
                  </span>
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[33.19rem] object-cover"
            alt=""
            src="/204@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-left">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>{`Peanuts & Peanut Butter`}</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  <span>
                    Peanuts and peanut butter are packed with nutrients like
                    protein, folate, magnesium, and vitamin E.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Eating peanuts and peanut butter may help make you feel full
                    due to their high protein content. In fact, studies show
                    that adding peanut butter to a high carb meal may help
                    reduce blood sugar spikes after the meaL.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <b>Protein Content</b>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    A 1-ounce (28.35-g) serving of peanuts provides 7.31 g of
                    protein, while a 2-tablespoon (32-g) serving of smooth
                    peanut butter provides 7.2 g of protein.
                  </span>
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[25.19rem] object-cover"
            alt=""
            src="/205@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>Storing Meat Safely</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                It's important to store and prepare meat safely to stop bacteria
                from spreading and to avoid food poisoning:
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Store raw meat or raw poultry in clean sealed containers on
                  the bottom shelf of the fridge, so the meat cannot touch or
                  drip onto other food
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Follow any storage instructions on the label and do not eat
                  meat after its "use by" date
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Store red meat or raw poultry in a freezer before its "use by"
                  date
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  If you cook meat that you're not going to eat straight away,
                  cool it as quickly as possible and then put it in the fridge
                  or freezer – remember to keep cooked meat separate from raw
                  meat and only reheat cooked meat once
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li>
              <span>
                <span>
                  Always thoroughly clean plates, utensils, surfaces and hands
                  straight away after they have touched raw or thawing meat
                  using warm soapy water or disinfectant cleaning products
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>Freezing Meat Safely</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>It's safe to freeze raw meat providing that you:</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Freeze it before the "use by" date</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Date and label meat in the freezer, following any freezing or
                  thawing instructions on the packaging
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Defrost meat in the microwave, using the defrost setting, if
                  you are going to cook it straight away
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Thaw meat fully in a fridge, if you want to defrost it and
                  cook it later – keep it in the fridge and use it within 2 days
                  of defrosting
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Cook food until it's steaming hot all the way through
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                When meat thaws, liquid can come out of it. This liquid will
                spread bacteria to any food, plates or surfaces that it touches.
                Keep the meat in a sealed container at the bottom of the fridge
                so that it cannot touch or drip onto other foods.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                If you defrost raw meat and then cook it thoroughly, you can
                freeze it again. But never reheat meat or any other food more
                than once as this could lead to food poisoning.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>Cooking Meat Safely</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>Follow the cooking instructions on the packaging.</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Some people wash meat before they cook it, but this actually
                increases your risk of food poisoning, because the water
                droplets splash onto surfaces and can contaminate them with
                bacteria.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                It's important to prepare and cook food safely. Cooking meat
                properly ensures that harmful bacteria on the meat are killed.
                If meat is not cooked all the way through, these bacteria may
                cause food poisoning.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Bacteria and viruses can be found all the way through poultry
                and certain meat products (such as burgers). This means you need
                to cook poultry and these sorts of meat products all the way
                through. When meat is cooked all the way through, its juices run
                clear and there is no pink or red meat left inside.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Meats and meat products that you should cook all the way through
                are:
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Poultry and game, such as chicken, turkey, duck and goose,
                  including liver
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Pork</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Offal, including liver</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Burgers and sausages</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Kebabs</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Rolled joints of meat</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                You can eat whole cuts of beef or lamb when they are pink inside
                – or "rare" – as long as they are cooked on the outside.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>These meats include:</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Steaks</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Cutlets</span>
              </span>
            </li>
            <li>
              <span>
                <span>Joints</span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>Liver Benefits</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Liver and liver products, such as liver pâté and liver sausage,
                are a good source of iron, as well as being a rich source of
                Vitamin A.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                You should be able to get all the vitamin A you need from your
                daily diet. Adults need:
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>700 micrograms of vitamin A per day for men</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>600 micrograms of vitamin A per day for women</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                However, because they are such a rich source of vitamin A, we
                should be careful not to eat too much liver and liver product
                foods.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Having too much vitamin A – more than 1.5mg (1,500 micrograms)
                of vitamin A per day from food and supplements – over many years
                may make your bones more likely to fracture when you are older.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                People who eat liver or liver pâté once a week may be having
                more than an average of 1.5mg of vitamin A per day. If you eat
                liver or liver products every week, you may want to consider
                cutting back or not eating them as often. Also, avoid taking any
                supplements that contain vitamin A and fish liver oils, which
                are also high in vitamin A.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Women who have been through the menopause, and older men, should
                avoid having more than 1.5mg of vitamin A per week from food and
                supplements. This is because older people are at a higher risk
                of bone fracture. This means not eating liver and liver products
                more than once a week, or having smaller portions. It also means
                not taking any supplements containing vitamin A, including fish
                liver oil, if they do eat liver once a week.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Pregnant women should avoid liver and liver products and vitamin
                A supplements.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>How Much Protein Should We Eat For Recomp?</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                The optimal protein intake for optimizing body composition
                remains a topic of ongoing research and debate among scientists.
                However, certain facts are well-established. Protein is the most
                crucial macronutrient when it comes to muscle repair and growth
                . It is also the most thermogenic macronutrient, meaning it
                leads to a higher calorie expenditure compared to carbohydrates
                or fats. Additionally, protein tends to be the most satiating
                macronutrient , making you feel fuller for a given calorie
                intake.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Considering these properties, protein can be considered the
                "super-macro" as it is essential for both muscle gain and fat
                loss. Therefore, for individuals pursuing these goals,
                determining the appropriate protein intake becomes of utmost
                importance. Before delving into the scientific literature, it is
                worth outlining our general philosophy on protein intake for
                body recomposition.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Traditionally, the belief was that consuming one gram of protein
                per pound of bodyweight was the optimal amount for maximum
                gains. However, more recent perspectives have suggested that
                this may be excessive and that a lower protein intake, around
                0.75 grams per pound, is sufficient. We, however, do not align
                entirely with either viewpoint.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                In the context of body recomposition, we firmly believe that
                protein plays a pivotal role. As mentioned earlier, it is the
                best macronutrient for muscle building and fat burning.
                Consequently, we advocate for a higher protein intake rather
                than a lower one. Insufficient protein intake could potentially
                hinder progress in terms of muscle gains and fat loss, all
                because of avoiding an extra chicken breast or protein shake. In
                this sense, we view a high protein intake as a form of anabolic
                insurance—an extra precautionary measure to ensure optimal
                results.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                It's worth noting that a high protein diet is generally safe,
                and existing literature consistently indicates no negative side
                effects on blood lipids, liver, bone, or kidney function .
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Furthermore, we recognize that individuals with different
                starting body fat percentages will require varying calorie and
                protein intakes. It's not as simple as recommending a single
                target for everyone based solely on body weight (e.g., one gram
                per pound). In the upcoming parts, we will delve into the
                relevant scientific research and discuss how individual factors
                such as body fat percentage impact protein requirements.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Since calculating daily protein intake relies on estimating body
                fat percentage to determine lean body mass, we have included a
                visual representation of various body fat percentages in Figure
                below. This can assist you in estimating your body fat
                percentage if you don't have access to more precise measurement
                tools outlined in . Remember, the estimation does not need to be
                precise at this stage; it serves as a starting point for setting
                up your macronutrient goals. Consistency and adjusting your
                intake over time will ultimately determine your success, so
                don't get too caught up in the initial estimation.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>What Science Says About Protein Intake :</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Dr. Bill Campbell from the University of South Florida conducted
                a study comparing the effects of low and high protein intake
                among female physique athletes undergoing an eight-week
                resistance training program . The low protein group was limited
                to a maximum of 0.55 grams of protein per pound of body weight,
                while the high protein group was prescribed a minimum of 1.1
                grams of protein per pound, with the option to exceed this
                amount.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                To determine specific protein intake values, we analyzed the
                participants' body composition data and macronutrient intakes
                reported in the study, focusing on protein consumption per pound
                of lean body mass (LBM), which is the key metric of interest. On
                average, the low protein group consumed 0.52 grams of protein
                per pound of fat-free mass, while the high protein group
                consumed an average of 1.44 grams of protein per pound of
                fat-free mass. Notably, both groups experienced muscle gain and
                fat loss, but the high protein group achieved significantly
                greater lean mass gains and fat loss.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                More specifically, the high protein group gained 4.6 pounds of
                fat-free mass while losing 2.4 pounds of fat mass, resulting in
                a two percent reduction in total body fat. The low protein
                group, on the other hand, only gained 1.32 pounds of fat-free
                mass while losing 1.76 pounds of fat mass, leading to a 1.1
                percent change in body fat percentage.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                It is important to consider that these female participants had
                previous resistance training experience and were required to
                deadlift 1.5 times their body weight to qualify for the study.
                Additionally, they were relatively lean, starting with a body
                fat percentage of around 22 percent, compared to the average of
                about 30 percent in the general population.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Furthermore, the researchers provided a visual representation
                illustrating the individual variation in responses to protein
                intake. It is worth noting that every subject in the high
                protein group gained lean mass, while some subjects in the low
                protein group actually lost lean mass.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Although the group averages showed positive changes in body
                composition for both groups, it is crucial to highlight that
                some individuals did experience muscle loss with the lower
                protein intake. This emphasizes our point that it is safer to
                err on the side of caution and consume a higher protein intake
                to avoid the risk of muscle loss observed in some subjects in
                the low protein group.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Lastly, it is worth considering that the high protein group
                consumed significantly more calories on a daily basis (an
                average of 1839kcal compared to 1416kcal), yet still experienced
                greater fat loss. While the possibility of misreporting calorie
                intake exists, we believe this finding underscores the impact of
                protein and its thermogenic and satiating effects.
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[96.75rem] h-[45.5rem] object-cover"
          alt=""
          src="/206@2x.png"
        />
        <div className="self-stretch relative text-[1.56rem] tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">
            As depicted in the figure above, it is evident that both groups
            experienced an increase in fat-free mass (muscle), but the high
            protein group exhibited significantly greater gains (the lines
            representing lean mass gains all point upwards, with a steeper slope
            in the high protein group).
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Another study conducted by Dr. Jose Antonio at Nova Southeastern
            University demonstrated the effect of increased protein intake on
            body recomposition. Seventy-three resistance-trained individuals
            were divided into a control group with an already high protein diet
            and an experimental group with an even higher protein intake.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            The control group was instructed to maintain their usual dietary
            habits throughout the study without any specific protein consumption
            instructions. On average, they consumed approximately 0.82-1.05
            grams of protein per pound of body weight per day, which is already
            considered a high protein intake based on existing literature.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            The experimental group was directed to consume a minimum of 1.36
            grams of protein per pound of body weight per day but had the option
            to exceed this amount. On average, they ended up consuming 1.55
            grams of protein per pound of body weight per day.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            It's worth mentioning that our protein recommendations are based on
            lean body mass to account for variations in body fat. In the figures
            below, which provide context, we suggest a protein intake range of
            1.2 to 1.6 grams per pound of lean body mass.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            After adjusting the data to account for lean body mass, the "normal
            protein" group (technically considered high protein) consumed around
            1.1 grams of protein per pound of lean body mass, while the "high
            protein" group consumed approximately 1.88 grams of protein per
            pound of lean body mass, which is exceptionally high and exceeds our
            recommendations.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Interestingly, both groups gained an average of 3.3 pounds of lean
            body mass. However, the very high protein group experienced
            significantly greater fat loss compared to the control group (-3.52
            pounds of fat mass versus -0.66 pounds of fat mass, respectively).
            This is particularly intriguing because the very high protein group
            consumed more calories per day (approximately 400kcal more) but
            still achieved greater fat loss.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            The authors of this study also provided a visual representation of
            individual responses, which can be observed in Figure below.
            Although both groups exhibited a decrease in body fat percentage on
            average, the higher protein group demonstrated a more substantial
            reduction.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            As with any research, not every subject experienced body
            recomposition, likely due to various factors such as training,
            nutrient timing, stress levels, sleep quality, and more. However,
            the overall trends clearly indicate that a higher protein intake is
            more beneficial for body recomposition.
          </p>
        </div>
        <img
          className="relative w-[72.38rem] h-[63.44rem] object-cover"
          alt=""
          src="/207@2x.png"
        />
        <div className="self-stretch relative text-[1.56rem] tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">
            Based on our thorough examination of the literature and the
            extrapolation of individual data, as well as our own experiences as
            competitive natural bodybuilders and coaches, it becomes evident why
            we advocate for a high protein intake within the range of 1.2-1.6
            grams per pound of lean body mass.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            We will delve into the subject of protein quality in greater detail
            when we explore various food sources in the upcoming chapters. But
            for now, since we have addressed the recommended daily protein
            intake, let's proceed to the other macronutrients, allowing you to
            achieve your daily macro targets.
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`PROTEIN INTAKE SUMMARY: `}</b>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <ul className="m-0 block text-inherit pl-[1.32rem]">
            <li className="mb-[false]">
              <i className="font-bold">{`Eat 1.2-1.6 grams of protein per lb of lean body mass (LBM). `}</i>
            </li>
            <li className="mb-[false]">
              <i className="font-bold">{`Calculate your LBM using your bodyweight and bodyfat percentage (see examples in Tables ) `}</i>
            </li>
            <li>
              <i className="font-bold">
                Be closer to 1.6 g/lb LBM the leaner you are. Be closer to 1.2
                g/lb LBM the more bodyfat you have.
              </i>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Diving into Protein</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                If you ask a typical gym enthusiast, they will likely mention
                egg whites, chicken, or whey protein as the go-to protein
                sources. On the other hand, a more knowledgeable individual
                focused on macronutrients might argue that the source of protein
                doesn't matter as long as you meet your macro goals.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                While we agree that reaching your daily protein target is
                crucial, it may not be sufficient for optimizing progress on its
                own. In this chapter, we will explore the concept of protein
                quality, considering whether certain protein sources are more
                anabolic per gram. Additionally, we will delve into protein
                timing, discussing the best time of day to consume protein, and
                protein distribution, addressing how to space out protein intake
                throughout the day. Let's begin by examining protein quality.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>
                Protein Quality : What Food Sources are Most Anabolic ?
              </span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Are all proteins the same? In short, no. Protein quality is
                determined by its amino acid profile. Complete proteins are
                those that contain all nine essential amino acids, which are
                vital for proper bodily function and survival. These amino acids
                are crucial for muscle protein synthesis, the process of
                building new muscle protein.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                To optimize muscle protein synthesis and overall protein
                quality, it's important to focus on consuming high-quality,
                complete protein sources. While following the recommended daily
                protein intake outlined above will likely ensure sufficient
                consumption of complete proteins, we aim to help you maximize
                your approach and get the most out of your diet. Let's delve
                deeper into the composition of protein, its varying quality
                among different food sources, and the intricacies of muscle
                protein synthesis.
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[102.63rem] h-[32.5rem] object-cover"
          alt=""
          src="/208@2x.png"
        />
        <div className="self-stretch relative text-[1.56rem] tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          To fuel muscle protein synthesis effectively, it is crucial to
          prioritize the consumption of high-quality, complete protein sources.
          While following the recommended daily protein intake will likely
          provide an adequate amount of complete proteins and essential amino
          acids, we must strive to optimize our approach further. Our aim is to
          empower you with the knowledge and strategies to extract the maximum
          benefits from your diet.
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Vegan Considerations For Protein Sources</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                For vegans, ensuring a sufficient intake of all essential amino
                acids can be challenging. Vegan protein sources generally have
                lower protein quality compared to animal products, making it
                harder to meet the recommended daily protein intake. One
                solution commonly adopted by vegans is to combine two or more
                incomplete protein sources to create a complete meal. A popular
                example is pairing rice and beans (lentils). Individually, rice
                lacks the essential amino acid lysine, and lentils lack
                methionine. However, when consumed together in a single meal,
                they provide all nine essential amino acids. This combination
                forms a complete meal that supports muscle building. See Figure
                below for a visual representation.
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[96.75rem] h-[50.44rem] object-cover"
          alt=""
          src="/2081@2x.png"
        />
        <div className="self-stretch relative text-[1.56rem] tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          Unfortunately, this approach still presents a minor challenge: vegan
          protein sources typically have lower overall amino acid content. For
          instance, a single serving of rice provides only about four grams of
          protein, which is insufficient to optimize the anabolic response.
          However, when combined with one serving of lentils, an additional 13
          grams of protein can be obtained. It's important to note that this
          combination also comes with an additional 70 grams of carbohydrates
          from these two food sources. To better understand this, let's quickly
          compare the amino acid profile and total protein content of one
          serving of rice and lentils with one serving of chicken breast.
        </div>
        <img
          className="relative w-[96.75rem] h-[69.25rem] object-cover"
          alt=""
          src="/209@2x.png"
        />
        <div className="self-stretch relative text-[1.56rem] tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">
            As shown in Table above , animal sources such as chicken breast are
            significantly richer in the nine essential amino acids (EAAs) and
            branch chain amino acids (BCAAs). They provide a more potent
            anabolic effect per gram of protein. Unfortunately, most vegan
            protein sources, although some are complete, tend to be higher in
            carbohydrates than in protein. For example, quinoa, often praised as
            a complete protein, contains 70 percent carbohydrates by weight. To
            match the 24 grams of protein found in a four-ounce serving of
            chicken breast (with minimal additional carbs), you would need to
            consume an additional 109 grams of carbohydrates from quinoa.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            However, there is still hope for vegans. Supplement companies have
            made significant progress in developing high-quality vegan protein
            powders that contain a full spectrum of essential amino acids. We
            highly recommend using a vegan protein blend that utilizes rice and
            pea protein as primary sources. This blend, often referred to as
            "vegan whey," closely matches the amino acid profile of whey
            protein. Recent advancements have also reduced the carbohydrate
            content in these supplements, while increasing the overall protein
            content.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            In addition to supplementing with a rice and pea protein blend,
            vegan athletes may benefit from considering BCAA supplementation to
            maximize the protein synthesis response of each meal. While not
            necessary, it can enhance the effectiveness of meals, particularly
            those with lower BCAA content. We suggest consuming an additional
            five grams of BCAAs (in a 2:1:1 ratio) as a supplement with meals,
            especially pre/post-workout, to optimize the muscle protein
            synthesis response, particularly if the meal naturally lacks
            sufficient leucine content.
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>{`Why are BCAA’S So Popular & What Purpose Do They Serve ?`}</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                When it comes to branch chain amino acids (BCAAs), they have
                gained immense popularity as sports supplements. This is
                primarily due to the recognition that the three BCAAs, namely
                leucine, isoleucine, and valine, play a pivotal role in
                initiating muscle protein synthesis (MPS). Leucine, in
                particular, has been identified as the key amino acid
                responsible for upregulating this process. While it may sound
                promising, let's hold off on rushing to buy a tub just yet.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Do BCAAs truly make a difference? The answer is both yes and no.
                Every meal presents an opportunity to maximize MPS and your
                muscle-building potential. Since leucine triggers MPS, consuming
                food sources low in BCAAs, especially leucine, means missing out
                on potential gains. In general, the more leucine in a meal, the
                more elevated MPS will be, up to a certain point. This means
                that consuming protein sources higher in leucine, such as whey
                or other animal sources, will enhance MPS to a greater extent.
                Additionally, if two meals contain equal amounts of leucine, the
                meal with a higher total protein content will stimulate MPS more
                effectively.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                However, there is a limit to how much MPS can be increased.
                Beyond this limit, adding more leucine or protein will not
                provide any additional benefits in synthesizing new muscle
                proteins. To illustrate this, let's use an analogy. Imagine
                turning up the dial on a light dimmer to increase muscle protein
                synthesis (MPS). Just like there is a maximum brightness level
                for a lightbulb, there is a limit to how much MPS can be
                elevated by consuming more leucine. Turning the dial past its
                maximum point will not make the bulb any brighter.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Now, let's understand the significance of having both BCAAs and
                a full spectrum of essential amino acids (EAAs) in a highly
                anabolic meal by using the analogy of a car. BCAAs can be
                compared to the key that starts the car, while EAAs are like the
                fuel that keeps the car running. Just as the key is required to
                initiate MPS, BCAAs are necessary, and EAAs are essential to
                sustain the muscle-building process. Therefore, while BCAAs play
                a crucial role in initiating muscle growth, simply consuming
                BCAAs alone will not lead to significant muscle gains. That's
                why we recommend consuming foods that are rich in both BCAAs and
                EAAs and, with a few exceptions for vegans, discourage BCAA
                supplementation.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                This is not to say that additional BCAAs will hinder the
                muscle-building process. However, in a diet already high in
                protein, they are unlikely to provide any additional
                muscle-building benefits
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[67.38rem] h-[67.13rem] object-cover"
          alt=""
          src="/210@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>Suggested Protein Sources</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Here is a compilation of protein-rich foods that we highly
                  recommend incorporating into your regular diet. These
                  selections have been carefully chosen based on their excellent
                  amino acid profile and significant leucine content. However,
                  please note that our approach to nutrition encourages
                  flexibility, and you are not limited to only these foods. It
                  is crucial to track your protein intake from all sources,
                  including those with trace or incomplete proteins and those
                  not listed below.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>PROTEIN SOURCES LIST:</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>Whey Protein</span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>Eggs</span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>Egg Whites</span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>
                    Meat (Chicken, Beef, Pork, Turkey, Elk, Game, etc)
                  </span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>Fish (all kinds)</span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>Dairy (i.e. yogurt, cheese)</span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>Vegan Protein Powder (Rice + Pea Blends)</span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>Soy Protein Isolate</span>
                </span>
              </span>
            </li>
            <li>
              <span>
                <span>
                  <span>Seaweed, Spirulina</span>
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>
                Protein Distribution: How should you space out our protein
                throughout the day ?
              </span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Now that we have established the optimal protein sources for
                maximizing muscle growth, let's delve into how we should
                distribute that protein throughout the day.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                One common misconception in nutrition is the belief that there
                is a limit to how much protein our bodies can absorb in one
                meal. Some claim it's 20 grams, others say 30 or 40 grams,
                arguing that anything beyond that amount goes to waste. However,
                this belief is an oversimplification. Technically, our bodies
                can absorb a substantial amount of protein in a single meal, as
                absorption refers to the passage of nutrients from the intestine
                into the bloodstream. So, you could consume 300 grams or more of
                protein in one sitting and still absorb most, if not all, of it
                effectively.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                The real question people are asking is, "How much protein can be
                utilized in a single meal for muscle building?" To answer this
                question, we need to examine the scientific evidence available.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Early studies seemed to support the idea of a maximum threshold,
                suggesting that 20-25 grams of high-quality protein, such as
                whey protein, was sufficient to maximize post-workout muscle
                protein synthesis. Another study comparing 20 grams to 40 grams
                of protein found no significant difference in muscle protein
                synthesis between the two amounts. At the time, this data
                implied that consuming over 20 grams of protein in a single meal
                wouldn't provide additional benefits for muscle growth.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                However, a closer look at this early research reveals that its
                conclusions may not apply to individuals aiming for body
                recomposition, as the training protocols used were too basic.
                The participants would perform only one exercise for one muscle
                group, consume their post-"workout" protein, and have their
                muscle's anabolic response measured. But let's be honest, when
                was the last time you went to the gym, did a few sets of leg
                extensions, and called it a full workout? Hopefully never, and
                the same goes for us.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                To address this potential flaw, in 2016, another group of
                researchers designed a more comprehensive study that reflected
                the training regimen typical lifters follow. Instead of a
                limited workout, they had participants engage in a full-body
                workout, including exercises like the bench press, leg press,
                and lat pulldown. After the workout, the researchers compared
                the muscle protein synthesis response to 20 grams versus 40
                grams of whey protein.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                In contrast to the earlier studies, this time the results showed
                that 40 grams of whey protein did lead to a significant increase
                in muscle protein synthesis compared to 20 grams. This data
                suggested that the upper limit of protein utilization in a
                single meal for muscle building might be higher than previously
                thought, depending on your training regimen.
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[67.38rem] h-[69.5rem] object-cover"
          alt=""
          src="/211@2x.png"
        />
        <div className="self-stretch relative text-[1.56rem] tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">
            <i>
              *”Line represents the mean for each condition. Mean ± SD of
              myofibrillar FSR following the ingestion of 20 and 40 g whey
              protein isolate for both groups combined (B). Significant
              difference between doses with all participants of each group
              combined (P = 0.005). FSR was determined over the 0–5 h period
              following protein ingestion.”
            </i>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            This concept should intuitively make sense because when you only
            train one muscle group or perform a low-volume session, the amount
            of muscle breakdown during the workout is much less compared to a
            high-volume full-body training session. Therefore, you wouldn't
            expect to utilize as much protein in a single post-workout meal
            following the low-volume protocol.
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>How much Protein should we eat per meal ?</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                The protein needed for recovery after an intense leg day is
                likely to be more than what is required after a quick arm
                workout. So, the amount of protein you can utilize in a single
                meal seems to depend on the type of training you engage in, with
                higher volume sessions involving more muscles and therefore
                utilizing more protein per meal.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Additionally, the protein needed per meal also depends on your
                total muscle mass. For instance, a 120-pound female would
                require less daily protein intake than a 180-pound male but
                would also be able to utilize less protein per meal for building
                new muscle.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                As you can see, the amount of protein you can utilize in a
                single meal for muscle building depends on various factors,
                including your training style and muscle mass. The more muscle
                you train in a workout and the greater your total muscle mass,
                the more protein you should be able to utilize per meal.
                Considering the research background and individual factors such
                as training style and total muscle mass, let's move on to
                practical calculations to determine precisely how much protein
                you should consume per meal.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                How much protein should we eat per meal? As mentioned earlier,
                while we require a complete range of essential amino acids to
                build new muscle tissue, the branch chain amino acid leucine
                plays a key role in triggering muscle growth (MPS). To answer
                the question of how much protein we should eat per meal, it is
                crucial to know the optimal amount of leucine per meal. By
                determining the maximum leucine threshold (beyond which
                additional leucine doesn't contribute to more MPS), we can
                calculate the necessary protein intake from leucine-rich food
                sources to maximize the MPS response for each meal.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Fortunately, one of the most respected protein researchers, Dr.
                Stuart Phillips, has identified the leucine threshold in humans.
                As we review Dr. Phillips' data and findings, it's important not
                to get too fixated on the specific numbers. Knowing the exact
                leucine content of every meal isn't necessary to determine how
                much protein to consume per meal (that would be overwhelming!).
                We are simply presenting all the data to demonstrate the basis
                of our recommendations. For those who prefer the bottom line,
                you can refer to the "Main Takeaways for Protein Distribution"
                at the end of this section. For the rest of us, let's continue.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Dr. Phillips reported that consuming 0.045 grams of leucine per
                kilogram of body weight (0.0205g/lb) per meal is the optimal
                amount for maximizing muscle protein synthesis. For example, if
                you weigh 170 pounds (approximately 77 kg), you would need about
                3.5 grams of leucine per meal to maximize the protein synthesis
                response. If you weigh 125 pounds (approximately 55 kg), you
                would need about 2.5 grams of leucine per meal to optimize the
                MPS response. In this case, 2.5 grams of leucine can be referred
                to as the leucine threshold for that individual.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Adding more leucine to the meal (either through additional
                protein or a scoop of BCAAs) would be akin to turning the dimmer
                dial beyond the maximum brightness of a light bulb. You can turn
                the dial further, but it won't make the bulb any brighter.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                With this information in mind, let's examine the graph below,
                which compares various food sources and the amount of each that
                would be necessary to consume 2.5 grams of leucine.
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[96.75rem] h-[41.13rem] object-cover"
          alt=""
          src="/212@2x.png"
        />
        <i className="self-stretch relative text-[1.56rem] tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">
            The provided diagram illustrates the amount of various foods that a
            125-pound individual would need to consume per meal to maximize the
            muscle protein synthesis (MPS) response. It's important to recognize
            that the protein requirement per meal depends, to some extent, on
            the food sources from which the protein is obtained.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            While it's beneficial to be aware of foods that are rich in leucine
            and to understand that not all protein sources of 20-30 grams have
            the same anabolic potency (refer to our Protein Sources List for
            recommendations), we don't expect you to determine the leucine
            content of every food and calculate the precise protein intake for
            each meal.
          </p>
        </i>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>
                Protein Timing : When Are The Important Times to Eat Protein ?
              </span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                First and foremost, it is essential to acknowledge that if you
                are already meeting your total daily protein goals and consuming
                four to six meals high in protein throughout the day, the
                specific timing of those meals becomes relatively less
                significant. We believe that the precise timing of your meals
                can largely be based on personal preference, scheduling, and
                your own body's feedback signals, such as hunger and satiety.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                We do not recommend forcing yourself to eat simply because it's
                a designated mealtime. It is also not advisable to anxiously
                wait for a predetermined amount of time to pass before consuming
                your next meal. These habits can be detrimental to maintaining a
                balanced and sustainable dietary approach and may ultimately
                lead to an unhealthy relationship with food.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                However, from a physiological perspective, it is worth noting
                that different protein sources and food combinations have
                varying rates of digestion, which can influence the optimal
                timing for their consumption.
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[96.75rem] h-[62.38rem] object-cover"
          alt=""
          src="/213@2x.png"
        />
        <div className="self-stretch relative text-[1.56rem] tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">
            As depicted in the above illustration, different proteins exhibit
            distinct digestion rates due to variations in their molecular
            structures. Whey protein, for instance, is rapidly digested, leading
            to a quick release of amino acids into the bloodstream. This
            characteristic has resulted in its extensive promotion as a
            post-workout supplement.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            In contrast, casein, another protein present in milk, undergoes
            slower digestion, resulting in a gradual and sustained release of
            amino acids into the bloodstream. Consequently, casein protein
            powders have been heavily marketed as a pre-bedtime protein source.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            We will elaborate on the fact that while consuming fast-digesting
            protein immediately after training is not urgent, and consuming
            slow-digesting protein before bed is not as crucial as meeting your
            total protein intake, specific timing strategies are still worth
            considering when planning your meals throughout the day.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            For instance, if we compare cod fish and steak, cod fish has a
            faster digestion rate. Therefore, a meal consisting of six ounces of
            cod with white rice will digest more quickly than a meal of six
            ounces of beef with white rice. However, the addition of fibrous
            vegetables and butter to either meal would slow down the digestion
            rate, as higher fiber and fat content delays digestion.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            You can leverage these timing principles to your advantage when
            anticipating longer periods without food, such as before bed or
            during a meal skip. For example, you can extend the anabolic
            response of any meal by incorporating protein sources with slower
            digestion rates or by consuming meals higher in fat and/or fiber.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Hence, we recommend consuming a substantial amount of high-quality
            protein before bed to maximize muscle building and recovery
            potential while you sleep. You can slow down the digestion rate of
            the pre-bedtime meal by increasing protein quantity, selecting
            slower-digesting proteins like casein or steak, and/or adding a
            serving of vegetables or fats before going to bed.
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>FAT</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Rather than dedicating a whole chapter to fats, we want to
                  emphasize their importance. While fats are vital for survival
                  and have various health benefits, their role in optimizing
                  body composition is relatively smaller compared to protein and
                  carbohydrates.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Protein is responsible for building muscle, promoting satiety,
                  and increasing thermogenesis. Carbohydrates play a central
                  role in fueling training performance, which drives muscle
                  growth. Nonetheless, fats still play essential roles in body
                  recomposition.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Dietary fats, including cholesterol, serve as building blocks
                  for steroid hormones, such as testosterone, which regulate
                  anabolic processes. Insufficient fat intake can suppress
                  testosterone levels, potentially hindering muscle building and
                  fat loss. Omega-3 and omega-6 fatty acids regulate metabolic
                  processes and inflammation, affecting recovery from training.
                  To ensure sufficient intake, we recommend consuming fatty fish
                  or considering fish oil supplementation.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Additionally, dietary fat aids in the absorption of
                  fat-soluble vitamins, which are crucial for health and
                  recovery. While we acknowledge that the complexities of
                  dietary lipids go beyond this course's scope, it's important
                  to understand that not all fats are equal. Avoiding dietary
                  fats entirely due to the fear of weight gain would be
                  shortsighted. Trans-fats should be limited or avoided due to
                  their negative impact on heart health.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  To maintain a balanced diet, focus on meeting your total daily
                  fat intake and consider pre- and post-workout considerations
                  outlined Later. We provide a list of suggested fat sources for
                  regular inclusion in your diet. While we encourage whole,
                  minimally processed foods for at least 80 percent of your fat
                  intake, the remaining 20 percent can be filled with foods you
                  personally enjoy or find convenient, adhering to an 80/20 rule
                  for food selection.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>FAT SOURCES LIST:</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>{`Salmon and other fatty fish (or fish oil supplements) `}</span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>{`Whole eggs `}</span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>{`Seeds (flax, chia, etc.) `}</span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>{`Nuts (walnuts, almonds, macadamia nuts, peanuts, etc.) `}</span>
                </span>
              </span>
            </li>
            <li>
              <span>
                <span>
                  <span>Nut butters (peanut butter, almond butter, etc.)</span>
                </span>
              </span>
            </li>
          </ul>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson34"}>
        <div className="rounded-32xl bg-gainsboro-200 box-border w-[25rem] flex flex-col items-center justify-center pt-[0.69rem] px-[3rem] pb-[1rem] max-w-[31.25rem] text-center text-[1.88rem] border-[1px] border-solid border-gray-300">
          <b className="self-stretch relative">Next Chapter</b>
        </div>
      </a>
      </div>
    </div>
  );
};

export default Lesson33;
